/**
 * Intentially left empty. Endpoints will be injected later as needed.
 * See https://redux-toolkit.js.org/rtk-query/usage/code-generation#usage
 */
import qs from 'qs';

import { datadogLogs } from '@datadog/browser-logs';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import type { RootState } from './store';

/**
 * Configures the home api to be used for generating endpoints.
 */
export const sageBaseHomeApi = createApi({
    baseQuery: fetchBaseQuery({
        baseUrl: import.meta.env.VITE_SAGE_HOME_BASE_URL,
        timeout: 30_000,

        // See https://redux-toolkit.js.org/rtk-query/api/fetchBaseQuery#setting-default-headers-on-requests
        prepareHeaders: (headers, { getState, endpoint }) => {
            const rootState: RootState = getState() as RootState;

            const bearerToken = rootState.auth?.bearerToken;
            if (bearerToken) {
                const authHeader = (bearerToken as string).toLowerCase().startsWith('bearer')
                    ? bearerToken
                    : `Bearer ${bearerToken}`;

                headers.set('Authorization', authHeader);
            } else {
                datadogLogs.logger.warn('No bearerToken set', { endpoint });
            }

            // Get team member RID from Redux state
            const profileRid = rootState.teamMember?.personRid;
            if (profileRid) {
                headers.set('x-sage-profile-rid', profileRid);
            }

            // Example of targeting endpoint to update image content type
            if (endpoint === 'uploadImageForResource') {
                headers.set('Content-Type', 'application/octet-stream');
            }

            return headers;
        },
        paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
    }),
    endpoints: () => ({}),
    tagTypes: [],
    reducerPath: 'sageHomeApi',
});
